import type { CommandProps } from '@tiptap/core';
import { TextSelection } from '@tiptap/pm/state';

// Chain after inserting a block. The insert leaves the block node-selected,
// where the next keystroke or paste would replace it.
export const landOnTextblock = ({ tr, dispatch, editor }: CommandProps): boolean => {
  if (!dispatch) return true;
  const pos = tr.selection.to;
  // Content followed the insert, so the caret already sits in a textblock.
  if (tr.doc.resolve(pos).parent.isTextblock) return true;
  if (!tr.doc.nodeAt(pos)?.isTextblock) {
    tr.insert(pos, editor.schema.nodes.paragraph.create());
  }
  tr.setSelection(TextSelection.create(tr.doc, pos + 1));
  return true;
};
